module.exports = __webpack_public_path__ + "static/img/checked-product-bg4.b5ac3402.png";